import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  label: "Dashboard",
};

export const HeaderLabelSlice = createSlice({
  name: "headerlabel",
  initialState,
  reducers: {
    setLabel: (state, action) => {
      state.label = action.payload;
    }
  }
});

export const { setLabel } = HeaderLabelSlice.actions;

export default HeaderLabelSlice.reducer;
